import { render } from "./KubernetesInstallation2.vue?vue&type=template&id=04ee51bc"
import script from "./KubernetesInstallation2.vue?vue&type=script&lang=js"
export * from "./KubernetesInstallation2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__